import React from "react";
import { getUnitOptions } from "../utils/utils";
import SpecManagerInput from "./SpecManagerInput";
import SpecManagerSelect from "./SpecManagerSelect";

export default function SpecsQuantitative({ specValues, unitOptions, onChange }) {
  const units = getUnitOptions(unitOptions);
  const [boundType, numberValue, unitValue] = specValues;

  return (
    <div className="SpecManager_SpecInputRow SpecManager_SpecInputRow--quantitative">
      <div className="SpecManager_SpecInputRowCell SpecManager_SpecInputRowCell--bound">
        <SpecManagerSelect
          options={["Max", "Min"]}
          selectedValue={boundType || "Max"}
          onSelect={(selected) => onChange([selected, numberValue, unitValue])}
        />
      </div>
      <div className="SpecManager_SpecInputRowCell SpecManager_SpecInputRowCell--value">
        <SpecManagerInput
          placeholder="eg: 20"
          value={numberValue}
          onChange={(value) => onChange([boundType, value, unitValue])}
        />
      </div>
      <div className="SpecManager_SpecInputRowCell SpecManager_SpecInputRowCell--unit">
        <SpecManagerSelect
          options={units}
          selectedValue={unitValue || "None"}
          onSelect={(selected) => onChange([boundType, numberValue, selected])}
        />
      </div>
    </div>
  );
}
